import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import {
    RouteWithLayout,
    PrivateRouteWithLayout,
    PreAuthRouteWithLayout
} from './components';

import {
    Main as MainLayout,
    Minimal as MinimalLayout
} from './layouts';

import {
    Login as LoginPage,
    Logout as LogoutPage,
    Register as RegisterPage,
    SyncSession as SyncSessionPage,
    RegistrationForm as RegistrationFormPage,

    InitPasswordReset as InitPasswordResetPage,
    PasswordReset as PasswordResetPage,
    TermsOfUse as TermsOfUsePage,
    ChangePassword as ChangePasswordPage,
    ConfirmEmail as ConfirmEmailPage,
    Home as HomePage,
    NotFound as NotFoundPage,
    AppInfo as AppInfoPage,

    // ReportView as ReportPage,

    ViewCompanyInfo as ViewCompanyInfoPage,
    UpdateCompanyInfo as UpdateCompanyInfoPage,
    ListApplications as ListApplicationPage,
    CreateApplication as CreateApplicationPage,
    ApplicationDetail as ApplicationDetailPage,
    EditAppProgramDetail as EditAppProgramDetailPage,
    EnQaMode as EnQaModePage,
    DsQaMode as DsQaModePage,

    // DQProPages
    DQProHome as DQProHomePage,
    DQProProducts as DQProProductsPage,
    DQProAssessmentDetails as DQProAssessmentDetailsPage,
    DQProSalesResources as DQProSalesResourcesPage,
    DQProClientList as DQProClientListPage,
    DQProOnboarded as DQProOnboardedPage,
    DQProOnboardingHowToStart as DQProOnboardingHowToStartPage,
    DQProOnboardingWhatYouCanDo as DQProOnboardingWhatYouCanDoPage,
    DQProOnboardingWhatCanYouEarn as DQProOnboardingWhatCanYouEarnPage,
    DQProOnboardingRewards as DQProOnboardingRewardsPage,
    DQProLearnerProgramList as DQProLearnerProgramListPage,
    DQProProgramName as DQProProgramNamePage,
    DQProProgDashboard as DQProProgDashboardPage,
    DQProProgOutline as DQProProgOutlinePage,
    DQProProgPreview as DQProProgPreviewPage,
    DQProAssessments as DQProAssessmentsPage,
    DQProAssessmentName as DQProAssessmentNamePage,
    DQProPreviewAssessment as DQProPreviewAssessmentPage,
    DQProAssessmentResult as DQProAssessmentResultPage,
    DQProAssessmentList as DQProAssessmentListPage,
    DQProProgCreation as DQProProgCreationPage,
    DQProProgCreationCopy as DQProProgCreationCopyPage,
    DQProProgCreationV2 as DQProProgCreationV2Page,
    DQProAlignment as DQProAlignmentPage,
    DQProSalesAnalytics as DQProSalesAnalyticsPage, DQProProgPreview,
} from './pages';

import CompanyInfoView from "./pages/CompanyInfo/View.page";
import SelectApplicationTypePage from "./pages/Application/SelectApplicationType.page";

const Routes = () => {
    return (
        <Switch>
            <Redirect
                exact
                from="/"
                to="/dq_pro/home"
            />
            <PreAuthRouteWithLayout
                component={RegistrationFormPage}
                exact
                layout={MinimalLayout}
                path="/signup"
            />
            <PreAuthRouteWithLayout
                component={LoginPage}
                exact
                layout={MinimalLayout}
                path="/login"
            />
            <PreAuthRouteWithLayout
                component={RegisterPage}
                exact
                layout={MinimalLayout}
                path="/register"
            />
            <PreAuthRouteWithLayout
                component={SyncSessionPage}
                exact
                layout={MinimalLayout}
                path="/sync_session"
            />

            <PreAuthRouteWithLayout
                component={InitPasswordResetPage}
                exact
                layout={MinimalLayout}
                path="/account/recover"
            />
            <PreAuthRouteWithLayout
                component={PasswordResetPage}
                exact
                layout={MinimalLayout}
                no_redirect={true}
                path="/auth/reset/password"
            />

            <PreAuthRouteWithLayout
                component={TermsOfUsePage}
                exact
                layout={MinimalLayout}
                no_redirect={true}
                path="/terms-of-use"
            />

            <PrivateRouteWithLayout
                component={ConfirmEmailPage}
                exact
                layout={MinimalLayout}
                path="/auth/confirm/email"
            />
            <PrivateRouteWithLayout
                component={DQProHomePage}
                exact
                layout={MainLayout}
                path="/home"
            />
            {/*<PrivateRouteWithLayout*/}
            {/*    component={ReportPage}*/}
            {/*    exact*/}
            {/*    layout={MainLayout}*/}
            {/*    path="/report"*/}
            {/*/>*/}
            <PrivateRouteWithLayout
                component={ViewCompanyInfoPage}
                exact
                layout={MainLayout}
                path="/company/view"
            />
            <PrivateRouteWithLayout
                component={UpdateCompanyInfoPage}
                exact
                layout={MainLayout}
                path="/company/update"
            />
            <PrivateRouteWithLayout
                component={ListApplicationPage}
                exact
                layout={MainLayout}
                path="/application/list"
            />
            <PrivateRouteWithLayout
                component={ApplicationDetailPage}
                exact
                layout={MainLayout}
                path="/application/detail"
            />
            <PrivateRouteWithLayout
                component={EditAppProgramDetailPage}
                exact
                layout={MainLayout}
                path="/application/edit/program"
            />
            <PrivateRouteWithLayout
                component={CreateApplicationPage}
                exact
                layout={MainLayout}
                path="/application/create"
            />


            <PrivateRouteWithLayout
                component={ChangePasswordPage}
                exact
                layout={MainLayout}
                path="/password/change"
            />
            <PrivateRouteWithLayout
                component={LogoutPage}
                exact
                layout={MainLayout}
                path="/logout"
            />

            <PrivateRouteWithLayout
                component={SelectApplicationTypePage}
                exact
                layout={MainLayout}
                path="/application/select"
            />


            {/*########################*/}
            {/*### DQPro -- ROUTES ###*/}
            {/*########################*/}


            <PrivateRouteWithLayout
                component={DQProHomePage}
                exact
                layout={MainLayout}
                path="/dq_pro/home"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardedPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingHowToStartPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/how-to-start"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingWhatYouCanDoPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/what-you-can-do"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingWhatCanYouEarnPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/what-can-you-earn"
            />
            {/*<PrivateRouteWithLayout*/}
            {/*    component={DQProOnboardingRewardsPage}*/}
            {/*    exact*/}
            {/*    layout={MainLayout}*/}
            {/*    path="/dq_pro/onboarded/rewards"*/}
            {/*/>*/}
            <PrivateRouteWithLayout
                component={DQProProductsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentDetailsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/product/view/:code"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentNamePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments/name"
            />
            <PrivateRouteWithLayout
                component={DQProPreviewAssessmentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/product/view/:code/preview"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentResultPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments/result"
            />
            <PrivateRouteWithLayout
                component={DQProSalesResourcesPage}
                exact
                layout={MainLayout}
                path="/dq_pro/sales/resources"
            />
            <PrivateRouteWithLayout
                component={DQProClientListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/clients/list"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/assessment/list"
            />
            <PrivateRouteWithLayout
                component={DQProProgCreationV2Page}
                exact
                layout={MainLayout}
                path="/dq_pro/program/creation"
            />
            <PrivateRouteWithLayout
                component={DQProProgCreationCopyPage}
                exact
                layout={MainLayout}
                path="/dq_pro/program/creation/copy"
            />
            <PrivateRouteWithLayout
                component={DQProProgCreationV2Page}
                exact
                layout={MainLayout}
                path="/dq_pro/program/creation/v2"
            />
            <PrivateRouteWithLayout
                component={DQProAlignmentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/alignment"
            />
            <PrivateRouteWithLayout
                component={DQProSalesAnalyticsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/sales-analytics"
            />
            <PrivateRouteWithLayout
                component={DQProLearnerProgramListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/learning/program/list"
            />
            <PrivateRouteWithLayout
                component={DQProProgramNamePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/name"
            />

            <PrivateRouteWithLayout
                component={DQProProgDashboardPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/dashboard/:code"
            />
            <PrivateRouteWithLayout
                component={DQProProgOutlinePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/:code/outline"
            />
                <PrivateRouteWithLayout
                component={DQProProgPreviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/:code/preview"
            />
            {/*########################*/}
            {/*### Miscellaneous -- ROUTES ###*/}
            {/*########################*/}

            <RouteWithLayout
                component={AppInfoPage}
                exact={false}
                layout={MinimalLayout}
                path="/app_info"
            />

            <RouteWithLayout
                component={EnQaModePage}
                exact={false}
                layout={MinimalLayout}
                path="/en_qa_mode"
            />

            <RouteWithLayout
                component={DsQaModePage}
                exact={false}
                layout={MinimalLayout}
                path="/ds_qa_mode"
            />

            <RouteWithLayout
                component={NotFoundPage}
                exact={false}
                layout={MinimalLayout}
                path="/"
            />

        </Switch>
    );
};

export default Routes;
